export class Language {
    id: number;

    lockVersion: number;
    shorttext: string;
    text: string;
    uniquename: string;
    sortorder: number;

    iso_639_1: string; // eslint-disable-line @typescript-eslint/naming-convention
    iso_639_2: string; // eslint-disable-line @typescript-eslint/naming-convention

    objGuid: string;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    constructor( id?: number, text?: string, uniquename?: string, iso_639_1?: string ) {
        this.id = id;
        this.text = text;
        this.uniquename = uniquename;
        this.iso_639_1 = iso_639_1;
    }
}
